import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";

/* Layout */
import Header from "./layout/header/index.jsx";
import Footer from "./layout/footer/index.jsx";



/* Global CSS */
import "./assets/css/style.css";
import "./assets/css/responsive.css";

/* Pages */
import Home from "./pages/home.jsx";
import AboutUs from "./pages/about-us.jsx";
import ContactUs from "./pages/contact-us.jsx";
import Recognition from "./pages/recognition.jsx";
import GalleryData from "./pages/gallery.jsx";
import MomentsData from "./pages/moments.jsx";
import ProgressData from "./pages/progress.jsx";
import ProjectData from "./pages/project.jsx";
import YouTubePage from "./pages/YouTubePage.jsx";

/* Single Page */
import ProjectSingle from "@common/ProjectSingle.jsx";

/* ===============================
   BODY CLASS HANDLER
================================ */
function BodyClassHandler() {
  const location = useLocation();

  useEffect(() => {
    document.body.className = "";

    let pageClass = "";

    if (location.pathname.startsWith("/projects/")) {
      pageClass = "project-single";
    } else if (location.pathname === "/") {
      pageClass = "home";
    } else {
      pageClass = location.pathname
        .replace("/", "")
        .replace(/\/+/g, "-");
    }

    document.body.classList.add(`page-${pageClass}`);
  }, [location.pathname]);

  return null;
}

/* ===============================
   APP COMPONENT
================================ */
function App() {

  return (
    <div className="App">
      <Router>
        {/* Loader Removed */}

        <BodyClassHandler />

        <Header />

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/projects" element={<ProjectData />} />
          <Route path="/team" element={<AboutUs />} />
          <Route path="/contact" element={<ContactUs />} />
          <Route path="/success" element={<Recognition />} />
          <Route path="/youtube" element={<YouTubePage />} />
          <Route path="/studio" element={<GalleryData />} />
          <Route path="/progress" element={<ProgressData />} />
          <Route path="/moments" element={<MomentsData />} />
          {/* Dynamic Project Single */}
          <Route path="/projects/:slug" element={<ProjectSingle />} />
        </Routes>

        <Footer />
      </Router>
    </div>
  );
}

export default App;
